import configurationSourceUrlService from '../../customise/service/configurationSourceUrlService';
import ICustomisedCar from '../../../../common/model/ICustomisedCar';
import { IBasketInitRequest } from '../../customise/api/basketApi';

const dealTransformer = {
  processDealPacksPayload: (
    car: ICustomisedCar,
    packs: string[],
    postcode: string,
    dealerId: string,
  ): Partial<IBasketInitRequest> => {
    return {
      vehicleId: car.carId,
      vehicleAccessories: car.accessories || [],
      vehicleAccessoryPacks: packs || [],
      vehicleServicePlan: car.servicePlan || null,
      dealerId,
      postcode,
    };
  },
  processDealAccessoriesPayload: (
    car: ICustomisedCar,
    accessories: string[],
    postcode: string,
    dealerId: string,
  ): Partial<IBasketInitRequest> => {
    return {
      vehicleId: car.carId,
      vehicleAccessories: accessories || [],
      vehicleAccessoryPacks: car.packs || [],
      vehicleServicePlan: car.servicePlan || null,
      dealerId,
      postcode,
    };
  },
  addConfigurationSourceUrl: (
    payload: Partial<IBasketInitRequest>,
    basePath: string,
    modelId: string,
    car: ICustomisedCar,
    route: string,
  ) => {
    return {
      ...payload,
      configurationSourceUrl: configurationSourceUrlService.getUrl(
        basePath,
        modelId,
        car.carId,
        {
          ...car,
          // @TODO: This is bad design. The payload and car parameters contain some of the same data,
          // thus violating single source of truth. This hack here is required because of bad design
          // leading to incorrect state in the car param.
          accessories: payload.vehicleAccessories,
          packs: payload.vehicleAccessoryPacks,
          servicePlan: payload.vehicleServicePlan,
        },
        route,
      ),
    } as IBasketInitRequest;
  },
};

export default dealTransformer;
